import styled from 'styled-components'

/**
 * The pencil was a bare svg with an onClick: clickable with a mouse, invisible to the keyboard and
 * to assistive tech. It is a real button now, so every route to it works.
 */
export const EditAssigneeButton = styled.button`
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  padding: 0;
`
